<template>
  <!-- <img src="@/assets/logo-teljes.png" alt="Prosper" class="mt-4" style="width: 320px;"> -->
  <v-layout style="height: calc(100vh - 140px);" fill-height row wrap align-center justify-center>
    <v-flex xs6>
      <v-card>
        <v-card-title class="headline">Bejelentkezés</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="loginForm.email"
            placeholder="Email"
            type="text"
            append-icon="account_circle"
          ></v-text-field>
          <v-text-field
            v-model="loginForm.password"
            append-icon="lock"
            placeholder="Jelszó"
            type="password"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$router.push({name: 'MainContent'});">Főoldal</v-btn>
          <v-btn @click="handleLogin()" :loading="isLoading">Belépés</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { auth } from "@/firebaseConfig";

export default {
  name: "Login",
  data() {
    return {
      isLoading: false,
      loginForm: {
        email: "",
        password: ""
      }
    };
  },
  computed: {},
  methods: {
    handleLogin() {
      this.isLoading = true;
      auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then(user => {
          this.$notify({
            group: "app",
            text: `Sikeres bejelentkezés`,
            type: "success"
          });
          this.$router.push({ name: "MainContent" });
        })
        .catch(err => {
          if (
            err.code === "auth/invalid-email" ||
            err.code === "auth/wrong-password"
          ) {
            this.$notify({
              group: "app",
              text: `Nem megfelelő email vagy jelszó`,
              type: "error "
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: calc(100vh - 140px);
}

.login-from {
  height: 60%;
  width: 70%;
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: yellow;
}

.login-from > input {
  height: 40px;
  width: 100%;
}
</style>